import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import { url } from '../../../js/api/endpoint';
import user from '../../../js/stores/user.js';
import themes from '../../../js/stores/theme.js';
import language from '../../../js/stores/language.js';
import carLoan from '../../../js/stores/car-loan.js';
import carLoanIssue from '../../../js/stores/car-loan-issue.js';
import carLoanItemLibrary from '../../../js/controllers/car-loan-item-lib.js';
import file from '../../../js/stores/file.js';
import { FileUploadWithPreview } from 'file-upload-with-preview';
var IssueTab = function IssueTab(props, _ref) {
  var $ = _ref.$,
    $h = _ref.$h,
    $f7 = _ref.$f7,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  var isOwner = false; //(user.getters.carId.value == props.data.CarMainData.CarId) ? true : false;
  var isBorrower = false;
  var uploadCarIssueFileList = null;
  var loanHasIssue = false;
  var issueData = {};
  var loanIssuePhotoBrowser;
  var isDisabled = "disabled";
  var disableTab = props.data.CarLoanData.CarLoanStatusId > 7 ? 'disabled' : '';
  var hide = props.data.CarLoanData.CarLoanStatusId > 7 ? 'hide-item' : '';
  var penaltyList = [];
  var userOnLoan = {};
  var currentTotalFine = 0;
  var currentLoanIssueId = 0;
  var extraSetup = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var issueItem, loanId, data, filteredList, loanPhotoList, loanImageList, i, urlFile;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return carLoanIssue.dispatch('getIssueByLoan', props.data.CarLoanData.CarLoanId);
          case 1:
            issueItem = _context.sent;
            loanId = props.data.CarLoanData.CarLoanId;
            _context.next = 2;
            return carLoanItemLibrary.hasOwnership(loanId);
          case 2:
            userOnLoan = _context.sent;
            if (Number(userOnLoan.value) == 1) {
              isOwner = userOnLoan.isOwner;
            }

            /* If loan has no issue */
            if (!(issueItem.status !== undefined && issueItem.status !== 200)) {
              _context.next = 3;
              break;
            }
            setTimeout(function () {
              configFileUploaders();
            }, 250);
            _context.next = 6;
            break;
          case 3:
            issueData = issueItem;
            currentLoanIssueId = issueItem.CarLoanIssueId;
            loanHasIssue = true;
            data = {
              loanIssueId: currentLoanIssueId,
              languageCode: language.getters.Name.value
            };
            _context.next = 4;
            return carLoanIssue.dispatch('getIssuePenaltyListLocalized', data);
          case 4:
            penaltyList = _context.sent;
            if (!(penaltyList.status !== undefined && penaltyList.status !== 200)) {
              _context.next = 5;
              break;
            }
            console.log(penaltyList.data.messages.error);
            return _context.abrupt("return");
          case 5:
            filteredList = penaltyList.filter(function (item) {
              return item.CarPenaltyCostIsUsed > 0;
            });
            currentTotalFine = 0;
            filteredList.forEach(function (item) {
              currentTotalFine += Number(item.PenaltyCostValue);
            });
          case 6:
            _context.next = 7;
            return file.dispatch('getCarLoanIssueImages', props.data.CarLoanData.CarLoanId);
          case 7:
            loanPhotoList = _context.sent;
            if (!(loanPhotoList.status !== undefined && loanPhotoList.status !== 200)) {
              _context.next = 8;
              break;
            }
            console.log(loanPhotoList.data.messages.error);
            return _context.abrupt("return");
          case 8:
            loanImageList = [];
            for (i = 0; i < loanPhotoList.length; i++) {
              if (!(loanPhotoList[i].FilePath.length == 0 && loanPhotoList[i].FileName.length == 0)) {
                urlFile = "".concat(url, "/").concat(loanPhotoList[i].FilePath, "/").concat(loanPhotoList[i].FileName);
                loanImageList.push(urlFile);
              }
            }
            if (loanImageList.length > 0) {
              loanIssuePhotoBrowser = $f7.photoBrowser.create({
                photos: loanImageList,
                theme: themes.getters.Name.value
              });
            }
            $update();
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function extraSetup() {
      return _ref2.apply(this, arguments);
    };
  }();
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          setTimeout(function () {
            extraSetup();
          }, 2000);
          $update();
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })));
  var configFileUploaders = function configFileUploaders() {
    uploadCarIssueFileList = new FileUploadWithPreview('car-issue-file-images', {
      maxFileCount: 4,
      multiple: true,
      accept: 'image/jpeg,image/jpg',
      text: {
        label: locale.translate('general.uploadImagesLabel', [4]),
        browse: locale.translate('general.browse'),
        chooseFile: locale.translate('general.chooseFileLabel'),
        selectedCount: locale.translate('general.selectedCountLabel')
      }
    });
  };
  var checkHasIssue = function checkHasIssue() {
    isDisabled = !document.querySelector('#has-issue-check').checked ? 'disabled' : '';
    $update();
  };
  var verifyPenalties = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
      var checkboxes, selectedHobbies, itemId, verifCheck, data, result;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            checkboxes = document.querySelectorAll('input[name="GetPenaltyValues"]:checked');
            selectedHobbies = Array.from(checkboxes).map(function (checkbox) {
              return {
                value: checkbox.value,
                itemId: checkbox.dataset.issueDetailId
              };
            });
            currentTotalFine = 0;
            selectedHobbies.forEach(function (selectedHobby) {
              currentTotalFine += Number(selectedHobby.value);
            });
            itemId = e.target.dataset.issueDetailId;
            verifCheck = $("#issue-detail-id-".concat(itemId)).prop('checked') ? 1 : 0;
            data = {
              CarLoanIssueDetailId: itemId,
              CarPenaltyCostIsUsed: verifCheck
            };
            _context3.next = 1;
            return carLoanIssue.dispatch('saveIssueDetail', data);
          case 1:
            result = _context3.sent;
            if (!(result.status !== undefined && result.status !== 200 && result.status !== 204)) {
              _context3.next = 2;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context3.abrupt("return");
          case 2:
            console.log("Penalty updated");
            $update();
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function verifyPenalties(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var saveLoanIssue = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var checkboxes;
      return _regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            checkboxes = document.querySelectorAll('input[name="GetPenaltyValues"]:checked');
            if (!(checkboxes.length < 1)) {
              _context5.next = 1;
              break;
            }
            $f7.toast.show({
              text: locale.translate('loan.issue.noIssueSelected')
            });
            return _context5.abrupt("return");
          case 1:
            $f7.dialog.confirm(locale.translate('loan.issue.askProceedIssue'), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
              var formContinueLoan, result;
              return _regeneratorRuntime.wrap(function (_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    formContinueLoan = new FormData();
                    formContinueLoan.append("CarLoanIssueId", issueData.CarLoanIssueId);
                    _context4.next = 1;
                    return carLoanIssue.dispatch('scaleLoanIssue', formContinueLoan);
                  case 1:
                    result = _context4.sent;
                    if (!(result.status !== undefined && result.status !== 200)) {
                      _context4.next = 2;
                      break;
                    }
                    $f7.toast.show({
                      text: result.data.messages.error
                    });
                    return _context4.abrupt("return");
                  case 2:
                    issueData.CarLoanIssueStatusId = 2;
                    $update();
                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4);
            })));
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function saveLoanIssue() {
      return _ref5.apply(this, arguments);
    };
  }();
  var saveCarImageList = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var issueComment, totalSelectedFiles;
      return _regeneratorRuntime.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (!document.querySelector('#has-issue-check').checked) {
              _context8.next = 4;
              break;
            }
            issueComment = document.getElementById('loan-issue-description').value;
            totalSelectedFiles = uploadCarIssueFileList.cachedFileArray.length;
            if (!(issueComment.length < 20)) {
              _context8.next = 1;
              break;
            }
            $f7.toast.show({
              text: locale.translate('loan.issue.description')
            });
            return _context8.abrupt("return");
          case 1:
            if (!(issueComment.length > 512)) {
              _context8.next = 2;
              break;
            }
            $f7.toast.show({
              text: locale.translate('loan.issue.descriptionTooLong')
            });
            return _context8.abrupt("return");
          case 2:
            if (!(totalSelectedFiles < 4)) {
              _context8.next = 3;
              break;
            }
            $f7.toast.show({
              text: locale.translate('general.uploadListLimitMessage', [4])
            });
            return _context8.abrupt("return");
          case 3:
            $f7.dialog.confirm(locale.translate('loan.issue.askCreateIssue'), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
              var formCarImageList, i, result, formIssue, resultingIssue;
              return _regeneratorRuntime.wrap(function (_context6) {
                while (1) switch (_context6.prev = _context6.next) {
                  case 0:
                    // Close loan as finished with issues
                    formCarImageList = new FormData();
                    formCarImageList.append('ReferenceId', props.data.CarLoanData.CarLoanId);
                    for (i = 0; i < totalSelectedFiles; i++) {
                      formCarImageList.append("loan-issue[".concat(i, "]"), uploadCarIssueFileList.cachedFileArray[i]);
                    }
                    _context6.next = 1;
                    return file.dispatch('uploadLoanIssueImages', formCarImageList);
                  case 1:
                    result = _context6.sent;
                    if (!(result.status !== undefined && result.status !== 201)) {
                      _context6.next = 2;
                      break;
                    }
                    $f7.toast.show({
                      text: result.data.messages.error
                    });
                    return _context6.abrupt("return");
                  case 2:
                    formIssue = new FormData();
                    formIssue.append('CarLoanId', props.data.CarLoanData.CarLoanId);
                    formIssue.append('CarLoanIssueComment', issueComment);
                    formIssue.append("CarLoanId", props.data.CarLoanData.CarLoanId);
                    formIssue.append("CarId", props.data.CarMainData.CarId);
                    formIssue.append("LenderId", props.data.CarMainData.ContactId);
                    formIssue.append("BorrowerId", props.data.CarLoanData.BorrowerId);
                    _context6.next = 3;
                    return carLoanIssue.dispatch('createLoanIssue', formIssue);
                  case 3:
                    resultingIssue = _context6.sent;
                    if (!(resultingIssue.status !== undefined && resultingIssue.status !== 201)) {
                      _context6.next = 4;
                      break;
                    }
                    $f7.toast.show({
                      text: resultingIssue.data.messages.error
                    });
                    return _context6.abrupt("return");
                  case 4:
                    $f7.toast.show({
                      text: locale.translate('loan.issue.newIssueCreated')
                    });
                    $f7.views.main.router.navigate('/', {
                      reloadAll: true,
                      ignoreCache: true
                    });
                  case 5:
                  case "end":
                    return _context6.stop();
                }
              }, _callee6);
            })));
            _context8.next = 5;
            break;
          case 4:
            $f7.dialog.confirm(locale.translate('loan.issue.askCloseLoan'), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
              var formData, result;
              return _regeneratorRuntime.wrap(function (_context7) {
                while (1) switch (_context7.prev = _context7.next) {
                  case 0:
                    formData = new FormData();
                    formData.append("CarLoanId", props.data.CarLoanData.CarLoanId);
                    formData.append("CarId", props.data.CarMainData.CarId);
                    formData.append("LenderId", props.data.CarMainData.ContactId);
                    formData.append("BorrowerId", props.data.CarLoanData.BorrowerId);
                    _context7.next = 1;
                    return carLoan.dispatch('closeLoanSuccessfully', formData);
                  case 1:
                    result = _context7.sent;
                    if (!(result.status !== undefined && result.status !== 201)) {
                      _context7.next = 2;
                      break;
                    }
                    $f7.toast.show({
                      text: result.data.messages.error
                    });
                    return _context7.abrupt("return");
                  case 2:
                    $f7.toast.show({
                      text: locale.translate('loan.issue.closedLoanSuccess')
                    });
                    $f7.views.main.router.navigate('/', {
                      reloadAll: true,
                      ignoreCache: true
                    });
                  case 3:
                  case "end":
                    return _context7.stop();
                }
              }, _callee7);
            })));
          case 5:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function saveCarImageList() {
      return _ref7.apply(this, arguments);
    };
  }();
  var openCarLoanIssueImages = /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      return _regeneratorRuntime.wrap(function (_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            loanIssuePhotoBrowser.open();
          case 1:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function openCarLoanIssueImages() {
      return _ref0.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page-content tab" id="tab-9-issue">
  <div class="block">
  ${props.data.CarLoanData.CarLoanStatusId > 6 ? $h`
    <div class="form list no-hairlines-md">
      <input id="current-loan-issue-id" name="CurrentLoanIssueId" type="hidden" value="${currentLoanIssueId}"/>
      <ul>
        <li class="${isDisabled}">
          <label class="item-checkbox item-content item-checkbox-icon-end">
            <input id="has-issue-check" name="HasIssueCheck" type="checkbox" checked="${loanHasIssue ? $h`checked` : $h``}" @click="${checkHasIssue}"/>
            <i class="icon icon-checkbox"></i>
            <div class="item-inner">
              <div class="item-title">${locale.translate('loan.issue.checkLabel')}</div>
            </div>
          </label>
        </li>
        <li>
          <div class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${locale.translate('loan.issue.description')}</div>
              <div class="item-input-wrap">
                <textarea id="loan-issue-description" name='LoanIssueDescription' placeholder="${locale.translate('loan.issue.placeholder')}" rows="10" cols="50"
                  readonly="${loanHasIssue ? $h`readonly`: $h``}">
                  ${issueData.CarLoanIssueComment}
                </textarea>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    ${penaltyList.length > 0 && $h`
    <div class="block-title">${locale.translate('loan.issue.tagMarkedIssues')}:</div>
    <!--
    <div class="block-title">Current fine total: €${currentTotalFine}</div>
    -->
    <div class="form list no-hairlines-md ${issueData.CarLoanIssueStatusId > 1 && $h`disabled`}">
      <ul>
        ${penaltyList.map((item) => $h`
        <li class="${!isOwner ? $h`disabled`: $h``}">
          <label class="item-content">
            <div class="item-inner">
              <div class="item-title">${item.LanguageKeyValue}</div>
              <div class="item-after">
                <div class="toggle">
                  <input id="issue-detail-id-${item.CarLoanIssueDetailId}" type="checkbox" name="GetPenaltyValues" value="${item.PenaltyCostValue}"
                  data-issue-detail-id="${item.CarLoanIssueDetailId}" @change="${verifyPenalties}" checked="${item.CarPenaltyCostIsUsed > 0 && $h`checked`}"/>
                  <span class="toggle-icon"></span>
                </div>
              </div>
            </div>
          </label>
        </li>
        `)}
      </ul>
    </div>
      ${isOwner && issueData.CarLoanIssueStatusId < 2 ? $h`
    <div class="block block-strong">
      <p class="grid grid-cols-3 xlarge-grid-cols-3">
        <div></div>
        <div>
          <a href="#" class="button button-small button-fill button-raised color-teal" @click="${saveLoanIssue}">
            <span class="material-symbols-outlined">checklist</span> ${locale.translate('loan.issue.buttonProceed')}
          </a>
        </div>
        <div></div>
      </p>
    </div>
      `:$h`
    <span></span>
      `}
    `}
    ${!loanHasIssue ? $h`
    <div id="car-issue-file-images" class="custom-file-container list block text-align-center ${isDisabled}" data-upload-id="car-issue-file-images"></div>
    <div class="block block-strong">
      <p class="grid grid-cols-3 xlarge-grid-cols-3">
        <div></div>
        <div>
          <a href="#" class="button button-small button-fill button-raised color-green ${hide}" @click="${saveCarImageList}" >
            <span class="material-symbols-outlined">taxi_alert</span>${locale.translate('general.save')}
          </a>
        </div>
        <div></div>
      </p>
    </div>
    `: $h`
    <div class="block block-strong">
      <p class="grid grid-cols-3 xlarge-grid-cols-3">
        <div></div>
        <div>
          <a href="#" class="button button-small button-fill button-raised color-green" @click="${openCarLoanIssueImages}">
            <span class="material-symbols-outlined">photo_camera</span> ${locale.translate('admin.sections.refund.edit.tagIssueImages')}
          </a>
        </div>
        <div></div>
      </p>
    </div>
    `}
    ` : $h`
    <span></span>
  `}
  </div>
</div>
`
    }
    ;
};
export default IssueTab;